// src/app/formdata-upload/base64-upload.component.ts

import { AfterContentChecked, AfterContentInit, Component, ContentChild, ElementRef, ViewChild } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import { MatSnackBar } from '@angular/material';
import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';
import { Observable } from 'rxjs/Observable';


declare var $:any;

@Component({
	selector: 'CargueArchivoBaseBeneficiarios',
	templateUrl: './CargueArchivoBaseBeneficiarios.component.html'
})
export class CargueArchivoBaseBeneficiariosComponent implements AfterContentInit{
	
	public loading: boolean = false;
	public bloquearBoton:boolean = true;
	public mensajes:Array<string> = new Array();
	public displayedColumns;
	public dataSource;
	public erroresTemp:Array<string> = new Array();
	public nombreArchivoCargue: string;
	public fechaDelArchivo: string;
	public nombreIdentificadorBase;
	public mostrarDiv=false;
	public materialExampleRadios:any
	public valorIndenmizacion:number

	public ocultarSnackBar: boolean = false;
	public mensaje: string = "";

	@ViewChild('fileInput') fileInput: ElementRef;
	@ViewChild('form') form;

	constructor( private _serviciosGenerales:ServiciosGenerales, public snackBar: MatSnackBar) {
		this.displayedColumns = ['mensaje'];
		this.dataSource = new ExampleDataSource(null);
		this.valorIndenmizacion=0;
		this.snackBar.dismiss();
	}

	private formulario:any;


	ngAfterContentInit() {
		$('#archivoLoad').on("change", function(){ 
			
			$('#uploadFile').val(
				$('#archivoLoad').val().replace('C:\\fakepath\\', '')
				); 
		});
	}

	onFileChange(event) {
		let reader = new FileReader();
		if(event.target.files && event.target.files.length > 0) {
			let file = event.target.files[0];
			this.nombreArchivoCargue = file.name,
			reader.readAsDataURL(file);
			reader.onload = () => {
				this.bloquearBoton = false;
				console.log('Recarga');
				this.formulario ={
					nombreArchivo: file.name,
					//filetype: file.type,
					infoArchivo: reader.result.split(',')[1]
				}
			};
		}
	}

	onSubmit() {
		const formModel = this.formulario;
		this.loading = true;
		this.dataSource = new ExampleDataSource(null);
		this.erroresTemp = new Array();

		
		if(formModel == undefined || formModel.infoArchivo == undefined || formModel.infoArchivo == ''){
			this.openSnackBarEspecial("Hay que seleccionar un archivo", "X");
			this.loading = false;
			return;	
		}

		//Se realiza validación minima con el nombre del archivo para evitar errores al extraer información del mismo
		//console.log('Nombre del Archivo:',this.nombreArchivoCargue);

		var cantidad =0;
		for(var i = 0; i < this.nombreArchivoCargue.length; i++) {
			if (this.nombreArchivoCargue[i].toLowerCase() === "_") {
				cantidad = cantidad+1;
			}
		}

		if(cantidad!=2 || this.nombreArchivoCargue.indexOf("BASE") == -1 || this.nombreArchivoCargue.indexOf("-") == -1 ){
			this.openSnackBarEspecial("Error en la estructura del NOMBRE del archivo Ejemplo: BASE 2 - 01_01_2020 - ENERO.xlsx ", "X");
			this.loading = false;
			return;	
		}

		this.fechaDelArchivo = this.nombreArchivoCargue.substring(this.nombreArchivoCargue.indexOf("_")-2,this.nombreArchivoCargue.indexOf("_")+8);
		//console.log("Fecha del Archivo ", this.fechaDelArchivo ,"-------", this.nombreArchivoCargue.indexOf("_")-2,this.nombreArchivoCargue.indexOf("_")+8)

		var vregexNaix = /^(?:(?:(?:0?[1-9]|1\d|2[0-8])[/-](?:0?[1-9]|1[0-2])|(?:29|30)[/-](?:0?[13-9]|1[0-2])|31[/](?:0?[13578]|1[02]))[/-](?:0{2,3}[1-9]|0{1,2}[1-9]\d|0?[1-9]\d{2}|[1-9]\d{3})|29[/-]0?2[/-](?:\d{1,2}(?:0[48]|[2468][048]|[13579][26])|(?:0?[48]|[13579][26]|[2468][048])00))$/
		
		if(!vregexNaix.test(this.fechaDelArchivo.replace("_","/").replace("_","/"))){
			this.openSnackBarEspecial("Error en la estructura del NOMBRE del archivo la fecha no tiene un formato Valido (DD/MM/YYYY)", "X");
			this.loading = false;
			return;	
		}
		
		
		//console.log(this.fechaDelArchivo.replace("_","/").replace("_","/"),"///",vregexNaix.test(this.fechaDelArchivo.replace("_","/").replace("_","/")));
		

		console.log("=============>",this.valorIndenmizacion);

		this._serviciosGenerales.post('cargarArchivoBaseBeneficiarios/'+this.valorIndenmizacion, formModel).subscribe(
			result=>{
				this.formulario ={}
				console.log(result);
				$("#archivoLoad").val(null);
				$("#uploadFile").val('');

				if(result.error == true){
					if(result.mensajes != undefined){

						for(let x in result.mensajes){
							this.erroresTemp.push(result.mensajes[x].mensaje)
						}
						this.dataSource = new ExampleDataSource(this.erroresTemp);
					}if(result.errores){
						for(let x in result.errores){
							this.erroresTemp.push(result.errores[x])
						}
						this.dataSource = new ExampleDataSource(this.erroresTemp);
					}else{
						this.openSnackBar(result.mensaje, "X");
					}

				}else{
					
					this.openSnackBar("Archivo "+result.mensaje+" cargado corectamente", "X");
				}
				this.loading = false;

			},error=>{
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("No se logró obtener la respuesta del servidor, por favor verificar si se efectuó este cargue", "X");
				this.loading = false;
				$("#archivoLoad").val(null);
			})
		
	}

	mostrar(){
		this.mostrarDiv = true;
		console.log(this.materialExampleRadios);
	}

	ocultar(){
		this.mostrarDiv = false;
		this.valorIndenmizacion=0;
		console.log(this.materialExampleRadios);
	}

	openSnackBar(message: string, action: string)
	{
		this.snackBar.open(message, action, {
			
		});
	}

	openSnackBarEspecial(message: string, action: string) {
		let snackBarRef =  this.snackBar.open(message, action);

		snackBarRef.onAction().subscribe(() => {

			this.ocultarSnackBar = false;
			this.mensaje = "";
		});
		
		let shand = document.getElementsByClassName('mat-snack-bar-container') as HTMLCollectionOf<HTMLElement>;		
		
		if (shand.length != 0) {
			    for (let i=0;i<shand.length;i++){
				shand[i].style.backgroundColor = "rgb(255 204 214)";
				}
			}
	}

}



export class ExampleDataSource {

	public data: Array<string>;


	constructor(sucursal:Array<string>){
		this.data = new Array();


		if(sucursal != null){
			for(let i of sucursal){
				this.data.push(i);
			}
		}
	}

	/** Connect function called by the table to retrieve one stream containing the data to render. */
	connect(): Observable<string[]>
	{
		return Observable.of(this.data);
	}

	disconnect()
	{
	}

}


// WEBPACK FOOTER //
// D:/REPO/FacturacionWeb/src/app/main/content/CargueArchivoBaseBeneficiarios/CargueArchivoBaseBeneficiarios.component.ts